import React, { useState } from "react";
import "../../Styles/Form/ViewScore.css";
import uncorrectanswericon from "../../Assets/uncorrectanswericon.png";
import correctanswericon from "../../Assets/correctanswericon.png";
import checkBoxResponse_icon from "../../Assets/checkBoxResponse_icon.svg";
import singleChoiceIcon from "../../Assets/singleChoiceIcon.svg";
import { useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const ViewScore = () => {
  const datass = [
    {
      sectionTitle: "Lorem Ipsum has been the industry's",
      des: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500sLorem Ipsum has been the industry's standard dummy text ever since the 1500s",
      questions: [
        {
          type: "Check box",
          questionText: "Which is the best city in the world",
          options: [
            { optionText: "Bestq" },
            { optionText: "Bestq2" },
            { optionText: "Best3" },
          ],
          correctAnswer: ["Bestq2", "Best3"],
          responses: [
            {
              answer: ["Bestq2"],
            },
          ],
          correctAnswersFeedback: "Lorem Ipsum has been the, industry's",
          inCorrectAnswersFeedback:
            "Lorem Ipsum has been the, industry'sLoressssssm Ipsum has been the, industry's",
        },
      ],
    },
  ];
  const url = process.env.REACT_APP_API;
  const formId = useParams().formId;
  const userId = useParams().userId;
  const [data, setData] = useState([]);

  // Filter responses based on userId
  const filteredData = data?.sections?.map((section) => {
    return {
      ...section,
      questions: section.questions.map((question) => {
        return {
          ...question,
          responses: question.responses.filter(
            (response) => response.userId === userId
          ),
        };
      }),
    };
  });
  useEffect(() => {
    const getFormDetails = async () => {
      try {
        const response = await axios.get(`${url}/forms/${formId}/${userId}`);
        if (response.status === 200) {
          setData(response.data.form);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getFormDetails();
  }, [formId, url, userId]);

  return (
    <div className="view-score-component">
      <div className="view-score-main-component">
        <div className="topbar-view-score-component">
          <div className="form-title-view-score">Surveyor form </div>
          {data?.generalSettings?.quizSettings.showPointValues && (
            <div
              className="input-text-sizes"
              style={{ justifyContent: "center" }}
            >
              <div
                style={{
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                100/200
              </div>
              <div className="text-sizes-model">Total Score</div>
            </div>
          )}
        </div>
        {filteredData?.map((sections, sIdx) => (
          <>
            <div className="view-score-section-questions" key={sIdx}>
              <div className="view-score-section-heaind-container">
                <div
                  className="view-score-section-title"
                  dangerouslySetInnerHTML={{ __html: sections.sectionTitle }}
                ></div>
                <div className="view-score-section-description">
                  {sections.des}
                </div>
              </div>
              <hr />
              {sections?.questions?.map((question, qIdx) => (
                <div key={qIdx} style={{ width: "100%" }}>
                  <AllQuestion
                    eachQuestion={question}
                    form={data.generalSettings.quizSettings}
                  />
                </div>
              ))}
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

const AllQuestion = ({ eachQuestion, form }) => {
  switch (eachQuestion.type) {
    case "Short Answer":
      return <ShortAnswer eachQuestion={eachQuestion} form={form} />;
    case "Paragraph":
      return <ParagraphAnswer eachQuestion={eachQuestion} form={form} />;
    case "Multiple Choice":
      return <MultipleChoice eachQuestion={eachQuestion} form={form} />;
    case "Check box":
      return <CheckBoxQuestion eachQuestion={eachQuestion} form={form} />;
    default:
      return null;
  }
};

const ShortAnswer = ({ eachQuestion, form }) => {
  console.log(form);
  return (
    <div className="view-score-question-container">
      <div className="view-score-question-text">
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <div>
            <img
              src={
                !eachQuestion.correctAnswer.includes(
                  eachQuestion.responses[0]?.answer
                )
                  ? uncorrectanswericon
                  : correctanswericon
              }
              alt="uncorrectanswericon"
            />
          </div>
          <div
            style={{
              width: "90%",
              color: eachQuestion.correctAnswer.includes(
                eachQuestion.responses[0]?.answer
              )
                ? "#00B348"
                : "#E52F2F",
            }}
            dangerouslySetInnerHTML={{ __html: eachQuestion.question }}
          ></div>
        </div>
        <div>0/100</div>
      </div>
      <div
        className="view-score-question-answer"
        style={{
          backgroundColor: eachQuestion.correctAnswer.includes(
            eachQuestion.responses[0]?.answer
          )
            ? "rgba(0, 179, 72, 0.1)"
            : "rgba(229, 47, 47, 0.09)",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {eachQuestion.responses[0]?.answer}
        <img
          src={
            !eachQuestion.correctAnswer.includes(
              eachQuestion.responses[0]?.answer
            )
              ? uncorrectanswericon
              : correctanswericon
          }
          alt="uncorrectanswericon"
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
        <div style={{ color: "#8493B2" }}>Correct answer</div>
        <div style={{ display: "flex" }}>
          {eachQuestion.correctAnswer?.map((answer, idx) => (
            <div style={{ marginRight: ".5rem" }} key={idx}>
              {" "}
              {answer},
            </div>
          ))}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
          {eachQuestion.feedBack && (
            <div className="question-answer-feedback">
              <div>Feedback</div>
              <div>{eachQuestion.feedBack}</div>
            </div>
          )}
          <div></div>
        </div>

        <div></div>
      </div>
    </div>
  );
};
const ParagraphAnswer = ({ eachQuestion }) => {
  return (
    <div className="view-score-question-container">
      <div className="view-score-question-text">
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <div>
            <img
              src={
                !eachQuestion.correct ? uncorrectanswericon : correctanswericon
              }
              alt="uncorrectanswericon"
            />
          </div>
          <div
            style={{
              width: "90%",
              color: eachQuestion.correctAnswer.includes(
                eachQuestion.responses[0]?.answer
              )
                ? "#00B348"
                : "#E52F2F",
            }}
            dangerouslySetInnerHTML={{ __html: eachQuestion.question }}
          ></div>
        </div>
        <div>0/100</div>
      </div>
      <div
        className="view-score-question-answer"
        style={{
          //   backgroundColor: eachQuestion.correct
          //     ? "rgba(0, 179, 72, 0.1)"
          //     : "rgba(229, 47, 47, 0.09)",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {eachQuestion.responses[0]?.answer}
        {/* <img
          src={!eachQuestion.correct ? uncorrectanswericon : correctanswericon}
          alt="uncorrectanswericon"
        /> */}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
        {eachQuestion.feedBack && (
          <div className="question-answer-feedback">
            <div>Feedback</div>
            <div>{eachQuestion.feedBack}</div>
          </div>
        )}
        <div></div>
      </div>
    </div>
  );
};

const MultipleChoice = ({ eachQuestion }) => {
  console.log(eachQuestion);
  return (
    <div className="view-score-question-container">
      <div className="view-score-question-text">
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <div>
            <img
              src={
                !eachQuestion.correctAnswer.includes(
                  eachQuestion.responses[0]?.answer
                )
                  ? uncorrectanswericon
                  : correctanswericon
              }
              alt="uncorrectanswericon"
            />
          </div>
          <div
            style={{
              width: "90%",
              color: eachQuestion.correctAnswer.includes(
                eachQuestion.responses[0]?.answer
              )
                ? "#00B348"
                : "#E52F2F",
            }}
            dangerouslySetInnerHTML={{ __html: eachQuestion.question }}
          ></div>
        </div>
        <div>0/100</div>
      </div>

      <div className="view-score-option-container">
        {eachQuestion.options.map((option, optionIndex) => {
          // Check if the option matches the user-made answer
          const isUserAnswer =
            eachQuestion.responses[0]?.answer === option.optionText;

          // Determine the background color based on whether it's a correct answer
          const backgroundColor = isUserAnswer
            ? eachQuestion.correctAnswer.includes(
                eachQuestion.responses[0]?.answer
              )
              ? "rgba(0, 179, 72, 0.1)" // Green for correct answer
              : "rgba(229, 47, 47, 0.1)" // Red for incorrect answer
            : "transparent"; // Default for unselected options

          return (
            <div
              className="question_response_choice"
              key={optionIndex}
              style={{
                justifyContent: "space-between",
                borderRadius: "6px",
                padding: "0.5rem",
                backgroundColor,
              }}
            >
              <div style={{ display: "flex", gap: "1rem" }}>
                <img
                  src={isUserAnswer ? checkBoxResponse_icon : singleChoiceIcon}
                  alt="choice icon"
                />
                <div>{option.optionText}</div>
              </div>
              {/* // src={isUserAnswer ? correctanswericon : uncorrectanswericon} */}
              {
                isUserAnswer ? (
                  eachQuestion.correctAnswer.includes(
                    eachQuestion.responses[0]?.answer
                  ) ? (
                    <img src={correctanswericon} alt="answer status icon" /> // Green for correct answer
                  ) : (
                    <img src={uncorrectanswericon} alt="answer status icon" />
                  ) // Red for incorrect answer
                ) : (
                  ""
                ) // Default for unselected options
              }
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
        <div style={{ color: "#8493B2" }}>Correct answer</div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1.5rem",
          }}
        >
          {eachQuestion.correctAnswer?.map((answer, idx) => (
            <div
              style={{
                marginRight: ".5rem",
                display: "flex",
                justifyContent: "space-between",
              }}
              key={idx}
            >
              <div style={{ display: "flex", gap: "1rem" }}>
                <img src={checkBoxResponse_icon} alt="choice icon" />
                {answer}
              </div>
              {/* <img src={correctanswericon} alt="answer status icon" /> */}
            </div>
          ))}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
          {/* {eachQuestion.correctAnswersFeedback ||
            (eachQuestion.inCorrectAnswersFeedback && (
              <div className="question-answer-feedback">
                <div>Feedback</div>
                <div>{eachQuestion.feedBack}</div>
              </div>
            ))} */}

          {eachQuestion.correctAnswer.includes(
            eachQuestion.responses[0]?.answer
          ) ? (
            eachQuestion.currentAnswerFeedback ? (
              <div className="question-answer-feedback">
                <div>Feedback</div>
                <div>{eachQuestion?.currentAnswerFeedback}</div>
              </div>
            ) : (
              ""
            )
          ) : eachQuestion.currentAnswerFeedback ? (
            <div className="question-answer-feedback">
              <div>Feedback</div>
              <div>{eachQuestion?.inCurrentAnswerFeedback}</div>
            </div>
          ) : (
            ""
          )}
          <div></div>
        </div>

        <div></div>
      </div>
    </div>
  );
};

// const CheckBoxQuestion = ({ eachQuestion }) => {
//   console.log(eachQuestion);
//   return (
//     <div className="view-score-question-container">
//       {/* Question Text */}
//       <div className="view-score-question-text">
//         <div style={{ display: "flex", gap: "0.5rem" }}>
//           <div>
//             <img
//               src={
//                 eachQuestion.correctAnswer.every((correctAnswer) =>
//                   eachQuestion.answer.includes(correctAnswer)
//                 ) &&
//                 eachQuestion.answer.every((userAnswer) =>
//                   eachQuestion.correctAnswer.includes(userAnswer)
//                 )
//                   ? correctanswericon
//                   : uncorrectanswericon
//               }
//               alt="answer status icon"
//             />
//           </div>
//           <div
//             style={{
//               width: "90%",
//               color:
//                 eachQuestion.correctAnswer.every((correctAnswer) =>
//                   eachQuestion.answer.includes(correctAnswer)
//                 ) &&
//                 eachQuestion.answer.every((userAnswer) =>
//                   eachQuestion.correctAnswer.includes(userAnswer)
//                 )
//                   ? "#00B348"
//                   : "#E52F2F",
//             }}
//           >
//             {eachQuestion.questionText}
//           </div>
//         </div>
//         <div>0/100</div>
//       </div>

//       {/* Options Section */}
//       <div className="view-score-option-container">
//         {eachQuestion.options.map((option, optionIndex) => {
//           // Check if the option is part of the user's answer
//           const isUserAnswer = eachQuestion.answer.includes(option.optionText);

//           // Determine background color based on correctness
//           const backgroundColor = isUserAnswer
//             ? eachQuestion.correctAnswer.includes(option.optionText)
//               ? "rgba(0, 179, 72, 0.1)" // Green for correct user answers
//               : "rgba(229, 47, 47, 0.1)" // Red for incorrect user answers
//             : "transparent"; // Default for unselected options

//           return (
//             <div
//               className="question_response_choice"
//               key={optionIndex}
//               style={{
//                 justifyContent: "space-between",
//                 borderRadius: "6px",
//                 padding: "0.5rem",
//                 backgroundColor,
//               }}
//             >
//               <div style={{ display: "flex", gap: "1rem" }}>
//                 <img
//                   src={isUserAnswer ? checkBoxResponse_icon : singleChoiceIcon}
//                   alt="choice icon"
//                 />
//                 <div>{option.optionText}</div>
//               </div>
//               {isUserAnswer && (
//                 <img
//                   src={
//                     eachQuestion.correctAnswer.includes(option.optionText)
//                       ? correctanswericon
//                       : uncorrectanswericon
//                   }
//                   alt="answer status icon"
//                 />
//               )}
//             </div>
//           );
//         })}
//       </div>

//       {/* Correct Answers Section */}
//       <div style={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
//         <div style={{ color: "#8493B2" }}>Correct Answer(s)</div>
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             gap: "1.5rem",
//           }}
//         >
//           {eachQuestion.correctAnswer.map((answer, idx) => (
//             <div
//               style={{
//                 marginRight: ".5rem",
//                 display: "flex",
//                 justifyContent: "space-between",
//               }}
//               key={idx}
//             >
//               <div style={{ display: "flex", gap: "1rem" }}>
//                 <img src={checkBoxResponse_icon} alt="choice icon" />
//                 {answer}
//               </div>
//               {/* <img src={correctanswericon} alt="answer status icon" /> */}
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Feedback Section */}
//       {eachQuestion.correctAnswer.every((correctAnswer) =>
//         eachQuestion.answer.includes(correctAnswer)
//       ) &&
//       eachQuestion.answer.every((userAnswer) =>
//         eachQuestion.correctAnswer.includes(userAnswer)
//       ) ? (
//         <div className="question-answer-feedback">
//           <div>Feedback</div>
//           <div>{eachQuestion.correctAnswersFeedback}</div>
//         </div>
//       ) : (
//         <div className="question-answer-feedback">
//           <div>Feedback</div>
//           <div>{eachQuestion.inCorrectAnswersFeedback}</div>
//         </div>
//       )}
//     </div>
//   );
// };

const CheckBoxQuestion = ({ eachQuestion, form }) => {
  // Assuming the response contains user answers, you need to check for those
  const userAnswer = eachQuestion.responses[0]?.answer || [];

  return (
    <div className="view-score-question-container">
      {/* Question Text */}
      <div className="view-score-question-text">
        <div style={{ display: "flex", gap: "0.5rem", width: "70%" }}>
          {form.showMissedQuestions && (
            <div>
              <img
                src={
                  // eachQuestion.correctAnswer.every((correctAnswer) =>
                  //   userAnswer.includes(correctAnswer)
                  // ) &&
                  userAnswer.every((userAnswer) =>
                    eachQuestion.correctAnswer.includes(userAnswer)
                  )
                    ? correctanswericon
                    : uncorrectanswericon
                }
                alt="answer status icon"
              />
            </div>
          )}
          <div
            style={{
              width: "90%",
              color: form.showMissedQuestions
                ? userAnswer.every((userAnswer) =>
                    eachQuestion.correctAnswer.includes(userAnswer)
                  )
                  ? "#00B348"
                  : "#E52F2F"
                : "#1B2436",
            }}
            dangerouslySetInnerHTML={{ __html: eachQuestion.question }}
          ></div>
        </div>
        {form.showPointValues && <div>0/100</div>}
      </div>

      {/* Options Section */}
      <div className="view-score-option-container">
        {eachQuestion.options.map((option, optionIndex) => {
          // Check if the option is part of the user's answer
          const isUserAnswer = userAnswer.includes(option.optionText);

          // Determine background color based on correctness
          const backgroundColor =
            form.showMissedQuestions && isUserAnswer
              ? eachQuestion.correctAnswer.includes(option.optionText)
                ? "rgba(0, 179, 72, 0.1)" // Green for correct user answers
                : "rgba(229, 47, 47, 0.1)" // Red for incorrect user answers
              : "transparent"; // Default for unselected options

          return (
            <div
              className="question_response_choice"
              key={optionIndex}
              style={{
                justifyContent: "space-between",
                borderRadius: "6px",
                padding: "0.5rem",
                backgroundColor,
              }}
            >
              <div style={{ display: "flex", gap: "1rem" }}>
                <img
                  src={isUserAnswer ? checkBoxResponse_icon : singleChoiceIcon}
                  alt="choice icon"
                />
                <div>{option.optionText}</div>
              </div>

              {form.showMissedQuestions && isUserAnswer && (
                <img
                  src={
                    eachQuestion.correctAnswer.includes(option.optionText)
                      ? correctanswericon
                      : uncorrectanswericon
                  }
                  alt="answer status icon"
                />
              )}
            </div>
          );
        })}
      </div>

      {/* Correct Answers Section */}
      {form.showCorrectAnswers && (
        <div style={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
          <div style={{ color: "#8493B2" }}>Correct Answer(s)</div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
            }}
          >
            {eachQuestion.correctAnswer.map((answer, idx) => (
              <div
                style={{
                  marginRight: ".5rem",
                  display: "flex",
                  justifyContent: "space-between",
                }}
                key={idx}
              >
                <div style={{ display: "flex", gap: "1rem" }}>
                  <img src={checkBoxResponse_icon} alt="choice icon" />
                  {answer}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Feedback Section */}
      {eachQuestion.correctAnswer.every((correctAnswer) =>
        userAnswer.includes(correctAnswer)
      ) &&
      userAnswer.every((userAnswer) =>
        eachQuestion.correctAnswer.includes(userAnswer)
      ) ? (
        <div className="question-answer-feedback">
          <div>Feedback</div>
          <div>{eachQuestion.currentAnswerFeedback}</div>
        </div>
      ) : (
        <div className="question-answer-feedback">
          <div>Feedback</div>
          <div>{eachQuestion.inCurrentAnswerFeedback}</div>
        </div>
      )}
    </div>
  );
};

export default ViewScore;
